export default {
  g: 'rgba(0, 255, 0, 0.8)',
  green: 'rgba(0, 255, 0, 0.8)',
  y: 'rgba(255, 255, 0, 0.8)',
  yellow: 'rgba(255, 255, 0, 0.8)',
  r: 'rgba(255, 0, 0, 0.8)',
  red: 'rgba(255, 0, 0, 0.8)',
  cyan: 'rgba(0, 255, 255, 0.8)',
  magenta: 'rgba(255, 0, 255, 0.8)',
  blue: 'rgba(0, 0, 255, 0.8)',
  chocolate: 'rgba(210, 105, 30, 0.8)',
  saddlebrown: 'rgba(139, 69, 19, 0.8)',
  sienna: 'rgba(160, 82, 45, 0.8)',
  royalblue: 'rgba(65, 105, 225, 0.8)',
  // below from https://www.rapidtables.com/web/color/RGB_Color.html
  // 'maroon':'rgba(128,0,0,0.8)',
  // 'darkred':'rgba(139,0,0,0.8)',
  // 'brown':'rgba(165,42,42,0.8)',
  // 'firebrick':'rgba(178,34,34,0.8)',
  // 'crimson':'rgba(220,20,60,0.8)',
  'tomato':'rgba(255,99,71,0.8)',
  'coral':'rgba(255,127,80,0.8)',
  // 'indianred':'rgba(205,92,92,0.8)',
  // 'lightcoral':'rgba(240,128,128,0.8)',
  // 'darksalmon':'rgba(233,150,122,0.8)',
  'salmon':'rgba(250,128,114,0.8)',
  // 'lightsalmon':'rgba(255,160,122,0.8)',
  // 'orangered':'rgba(255,69,0,0.8)',
  'darkorange':'rgba(255,140,0,0.8)',
  'orange':'rgba(255,165,0,0.8)',
  // 'gold':'rgba(255,215,0,0.8)',
  // 'darkgoldenrod':'rgba(184,134,11,0.8)',
  'goldenrod':'rgba(218,165,32,0.8)',
  // 'palegoldenrod':'rgba(238,232,170,0.8)',
  // 'darkkhaki':'rgba(189,183,107,0.8)',
  // 'khaki':'rgba(240,230,140,0.8)',
  'olive':'rgba(128,128,0,0.8)',
  // 'yellowgreen':'rgba(154,205,50,0.8)',
  'darkolivegreen':'rgba(85,107,47,0.8)',
  'olivedrab':'rgba(107,142,35,0.8)',
  // 'lawngreen':'rgba(124,252,0,0.8)',
  // 'chartreuse':'rgba(127,255,0,0.8)',
  // 'greenyellow':'rgba(173,255,47,0.8)',
  // 'darkgreen':'rgba(0,100,0,0.8)',
  // 'green':'rgba(0,128,0,0.8)',
  // 'forestgreen':'rgba(34,139,34,0.8)',
  'lime':'rgba(0,255,0,0.8)',
  'limegreen':'rgba(50,205,50,0.8)',
  // 'lightgreen':'rgba(144,238,144,0.8)',
  // 'palegreen':'rgba(152,251,152,0.8)',
  'darkseagreen':'rgba(143,188,143,0.8)',
  // 'mediumspringgreen':'rgba(0,250,154,0.8)',
  'springgreen':'rgba(0,255,127,0.8)',
  // 'seagreen':'rgba(46,139,87,0.8)',
  // 'mediumaquamarine':'rgba(102,205,170,0.8)',
  'mediumseagreen':'rgba(60,179,113,0.8)',
  // 'lightseagreen':'rgba(32,178,170,0.8)',
  // 'darkslategray':'rgba(47,79,79,0.8)',
  'teal':'rgba(0,128,128,0.8)',
  // 'darkcyan':'rgba(0,139,139,0.8)',
  // 'aqua':'rgba(0,255,255,0.8)',
  // 'cyan':'rgba(0,255,255,0.8)',
  // 'lightcyan':'rgba(224,255,255,0.8)',
  // 'darkturquoise':'rgba(0,206,209,0.8)',
  // 'turquoise':'rgba(64,224,208,0.8)',
  // 'mediumturquoise':'rgba(72,209,204,0.8)',
  // 'paleturquoise':'rgba(175,238,238,0.8)',
  // 'aquamarine':'rgba(127,255,212,0.8)',
  // 'powderblue':'rgba(176,224,230,0.8)',
  // 'cadetblue':'rgba(95,158,160,0.8)',
  // 'steelblue':'rgba(70,130,180,0.8)',
  // 'cornflowerblue':'rgba(100,149,237,0.8)',
  // 'deepskyblue':'rgba(0,191,255,0.8)',
  // 'dodgerblue':'rgba(30,144,255,0.8)',
  // 'lightblue':'rgba(173,216,230,0.8)',
  // 'skyblue':'rgba(135,206,235,0.8)',
  // 'lightskyblue':'rgba(135,206,250,0.8)',
  // 'midnightblue':'rgba(25,25,112,0.8)',
  // 'navy':'rgba(0,0,128,0.8)',
  // 'darkblue':'rgba(0,0,139,0.8)',
  // 'mediumblue':'rgba(0,0,205,0.8)',
  'blueviolet':'rgba(138,43,226,0.8)',
  // 'indigo':'rgba(75,0,130,0.8)',
  // 'darkslateblue':'rgba(72,61,139,0.8)',
  // 'slateblue':'rgba(106,90,205,0.8)',
  // 'mediumslateblue':'rgba(123,104,238,0.8)',
  // 'mediumpurple':'rgba(147,112,219,0.8)',
  'darkmagenta':'rgba(139,0,139,0.8)',
  // 'darkviolet':'rgba(148,0,211,0.8)',
  // 'darkorchid':'rgba(153,50,204,0.8)',
  // 'mediumorchid':'rgba(186,85,211,0.8)',
  // 'purple':'rgba(128,0,128,0.8)',
  // 'thistle':'rgba(216,191,216,0.8)',
  'plum':'rgba(221,160,221,0.8)',
  // 'violet':'rgba(238,130,238,0.8)',
  // 'magenta/fuchsia':'rgba(255,0,255,0.8)',
  // 'orchid':'rgba(218,112,214,0.8)',
  // 'mediumvioletred':'rgba(199,21,133,0.8)',
  // 'palevioletred':'rgba(219,112,147,0.8)',
  // 'deeppink':'rgba(255,20,147,0.8)',
  // 'hotpink':'rgba(255,105,180,0.8)',
  // 'lightpink':'rgba(255,182,193,0.8)',
  'pink':'rgba(255,192,203,0.8)',
  // 'antiquewhite':'rgba(250,235,215,0.8)',
  // 'beige':'rgba(245,245,220,0.8)',
  'bisque':'rgba(255,228,196,0.8)',
  // 'blanchedalmond':'rgba(255,235,205,0.8)',
  'wheat':'rgba(245,222,179,0.8)',
  // 'cornsilk':'rgba(255,248,220,0.8)',
  // 'lemonchiffon':'rgba(255,250,205,0.8)',
  // 'lightgoldenrodyellow':'rgba(250,250,210,0.8)',
  // 'lightyellow':'rgba(255,255,224,0.8)',
  'peru':'rgba(205,133,63,0.8)',
  // 'sandybrown':'rgba(244,164,96,0.8)',
  // 'burlywood':'rgba(222,184,135,0.8)',
  // 'tan':'rgba(210,180,140,0.8)',
  // 'rosybrown':'rgba(188,143,143,0.8)',
  // 'moccasin':'rgba(255,228,181,0.8)',
  'navajowhite':'rgba(255,222,173,0.8)',
  // 'peachpuff':'rgba(255,218,185,0.8)',
  // 'mistyrose':'rgba(255,228,225,0.8)',
  'lavenderblush':'rgba(255,240,245,0.8)',
  // 'linen':'rgba(250,240,230,0.8)',
  // 'oldlace':'rgba(253,245,230,0.8)',
  // 'papayawhip':'rgba(255,239,213,0.8)',
  // 'seashell':'rgba(255,245,238,0.8)',
  // 'mintcream':'rgba(245,255,250,0.8)',
  'slategray':'rgba(112,128,144,0.8)',
  // 'lightslategray':'rgba(119,136,153,0.8)',
  // 'lightsteelblue':'rgba(176,196,222,0.8)',
  // 'lavender':'rgba(230,230,250,0.8)',
  // 'floralwhite':'rgba(255,250,240,0.8)',
  // 'aliceblue':'rgba(240,248,255,0.8)',
  // 'ghostwhite':'rgba(248,248,255,0.8)',
  'honeydew':'rgba(240,255,240,0.8)',
  'ivory':'rgba(255,255,240,0.8)'
  // , 'azure':'rgba(240,255,255,0.8)',
  // 'snow':'rgba(255,250,250,0.8)',
  // 'black':'rgba(0,0,0,0.8)',
  // 'dimgray/dimgrey':'rgba(105,105,105,0.8)',
  // 'gray/grey':'rgba(128,128,128,0.8)',
  // 'darkgray/darkgrey':'rgba(169,169,169,0.8)',
  // 'silver':'rgba(192,192,192,0.8)',
  // 'lightgray/lightgrey':'rgba(211,211,211,0.8)',
  // 'gainsboro':'rgba(220,220,220,0.8)',
  // 'whitesmoke':'rgba(245,245,245,0.8)'
}
